function applyMetaInfo(vm) {
  const meta = vm.$options.metaInfo;
  if (!meta) return;
  const resolved = typeof meta === 'function' ? meta.call(vm) : meta;
  if (resolved && resolved.title) {
    document.title = resolved.title;
  }
}

export default function registerMetaInfo(app) {
  app.mixin({
    mounted() {
      applyMetaInfo(this);
    },
    updated() {
      applyMetaInfo(this);
    },
  });
}
